
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sexleketoy/bdsm",
      function () {
        return require("private-next-pages/sexleketoy/bdsm/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sexleketoy/bdsm"])
      });
    }
  